import { AssistantValue } from "../../../../../services/api/instances/assistantsApi/types";
import { NormalizedStorageObject } from "../../../../../services/api/instances/storageApi/types/object_types";
import { GenericSelect } from "../../../../../shared/components/AppGenericSelect";
import { getFilteredAssistantObjects } from "../../helpers";

interface Props {
  assistants: NormalizedStorageObject<AssistantValue>[];
  assistant: NormalizedStorageObject<AssistantValue> | null;
  onSelectAssistant: (
    assistant: NormalizedStorageObject<AssistantValue> | null,
  ) => void;
  emptyOptionLabel?: string;
  isDisabled?: boolean;
}

export const AssistantSelect = (props: Props) => {
  return (
    <GenericSelect<NormalizedStorageObject<AssistantValue>>
      options={getFilteredAssistantObjects(props.assistants)}
      value={props.assistant}
      onChange={props.onSelectAssistant}
      getLabel={(asst) => asst.friendly_name}
      getValue={(asst) => asst.id}
      emptyOptionLabel={
        props.emptyOptionLabel ? props.emptyOptionLabel : undefined
      }
      isDisabled={props.isDisabled}
      placeholder={"Выберите ассистента"}
    />
  );
};
